module.exports = "img {\n  margin: 4px 15px 0px -5px; }\n\nol {\n  display: inline-block;\n  padding-top: 0px;\n  margin-top: 15px;\n  vertical-align: top; }\n\nli a {\n  font-weight: bold; }\n\nli:last-child a {\n  position: absolute;\n  left: 163px;\n  font-size: 32px;\n  font-weight: 900;\n  top: 40px; }\n\nli + li:before {\n  content: '> ';\n  font-weight: bold; }\n\n.container {\n  position: relative;\n  margin-top: -25px;\n  padding-bottom: 30px; }\n\n.gray-text {\n  color: #A7A7A7; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/breadcrumb/breadcrumb.component.scss
// module id = ./src/app/breadcrumb/breadcrumb.component.scss
// module chunks = main